import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  FamsAnnualDashboardQueryParams,
  FamsAnnualDashboardResponse,
} from './types/annual-dashboard';

const request = createAppRequest();

export async function getFamsAnnualDashboard(
  params?: FamsAnnualDashboardQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsAnnualDashboardResponse>('/bff/fams/annual-dashboard', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
